(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gw-card-add"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gw-card-add')) {
 customElements.define('gw-card-add', class extends HTMLElement {
  connectedCallback() {
   if (this.bound) return;
   this.bound = true;
   this.addEventListener('submit', async event => {
    event.preventDefault();
    const button = this.querySelector('button');
    const status = this.querySelector('[role="status"]');
    if (button.disabled) return;
    button.disabled = true;
    status.textContent = this.dataset.loading;
    const drawer = document.querySelector('cart-drawer');
    drawer?.setActiveElement?.(button);
    let added = false;
    try {
     const response = await fetch(window.routes.cart_add_url, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:this.querySelector('[name="id"]').value,quantity:1}],sections:['cart-drawer','cart-icon-bubble'],sections_url:window.location.pathname})});
     const result = await response.json();
     if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
     added = true;
     status.textContent = this.dataset.added;
     if (drawer && result.sections?.['cart-drawer']) {drawer.classList.remove('is-empty');drawer.renderContents(result);}
     else window.location.assign(window.routes.cart_url);
    } catch(error) {
     if (added) window.location.assign(window.routes.cart_url);
     else status.textContent = error.message || this.dataset.error;
    } finally {button.disabled = false;}
   });
  }
 });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gwm-recommendations"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gwm-recommendations')) {
 customElements.define('gwm-recommendations', class extends HTMLElement {
  connectedCallback() {
   if (this.bound) return;
   this.bound = true;
   const add = async event => {
    const form = event.target.closest('[data-gwm-add]');
    if (!form) return;
    if (event.type === 'click' && (form.tagName !== 'DIV' || !event.target.closest('button'))) return;
    event.preventDefault();
    const button = form.querySelector('button');
    const status = form.querySelector('[role="status"]');
    if (button.disabled) return;
    button.disabled = true;
    status.textContent = this.dataset.loading;
    const drawer = this.closest('cart-drawer') || (this.closest('.gw-bestsellers') ? document.querySelector('cart-drawer') : null);
    const mainItems = document.getElementById('main-cart-items');
    const mainFooter = document.getElementById('main-cart-footer');
    const sections = drawer ? ['cart-drawer', 'cart-icon-bubble'] : [mainItems?.dataset.id, mainFooter?.dataset.id, 'cart-icon-bubble'].filter(Boolean);
    let added = false;
    try {
     const response = await fetch(window.routes.cart_add_url, { method: 'POST', headers: {'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({items:[{id:form.querySelector('[name="id"]').value,quantity:1}],sections,sections_url:window.location.pathname}) });
     const result = await response.json();
     if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
     added = true;
     status.textContent = this.dataset.added;
     if (drawer && result.sections?.['cart-drawer']) {
      drawer.renderContents(result);
      setTimeout(() => drawer.querySelector('#CartDrawer-Checkout')?.focus(), 100);
     } else if (mainItems && mainFooter && sections.every(id => result.sections?.[id])) {
      const parser = new DOMParser();
      for (const [element,id,selector] of [[mainItems,mainItems.dataset.id,'.js-contents'],[mainFooter,mainFooter.dataset.id,'.js-contents'],[document.getElementById('cart-icon-bubble'),'cart-icon-bubble','.shopify-section']]) {
       const fresh = parser.parseFromString(result.sections[id],'text/html').querySelector(selector);
       const target = element?.querySelector(selector) || element;
       if (fresh && target) target.innerHTML = fresh.innerHTML;
      }
      document.querySelector('cart-items')?.querySelector('[name="updates[]"]')?.focus();
     } else window.location.assign(window.routes.cart_url);
    } catch(error) {
     if (added) window.location.assign(window.routes.cart_url);
     else {status.textContent = error.message || this.dataset.error; button.disabled = false;}
    }
   };
   this.addEventListener('submit', add);
   this.addEventListener('click', add);
  }
 });
}
  } catch(e) { console.error(e); }
})();

})();
